/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RewardsDistributor } from "../RewardsDistributor";

export class RewardsDistributor__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _fundManagers: string[],
    overrides?: Overrides
  ): Promise<RewardsDistributor> {
    return super.deploy(
      _nexus,
      _fundManagers,
      overrides || {}
    ) as Promise<RewardsDistributor>;
  }
  getDeployTransaction(
    _nexus: string,
    _fundManagers: string[],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_nexus, _fundManagers, overrides || {});
  }
  attach(address: string): RewardsDistributor {
    return super.attach(address) as RewardsDistributor;
  }
  connect(signer: Signer): RewardsDistributor__factory {
    return super.connect(signer) as RewardsDistributor__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardsDistributor {
    return new Contract(address, _abi, signerOrProvider) as RewardsDistributor;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_fundManagers",
        type: "address[]",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "funder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DistributedReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "RemovedFundManager",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "Whitelisted",
    type: "event",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "addFundManager",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract IRewardsDistributionRecipient[]",
        name: "_recipients",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "distributeRewards",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "removeFundManager",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
